import { reduxForm } from 'redux-form'
import PoolCoverCreate from './create_cover'
import { NEW_CAMPAIGN_ID, setData } from 'redux/modules/campaign'
import { goBack } from 'react-router-redux'
import { getCampaignSelector } from 'redux/selectors/campaign'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)

  return {
    initialValues: {
      backgroundImage: campaign.background_image,
      backgroundImageFilename: campaign.background_image_filename,
      backgroundPan: campaign.background_pan,
      gradientColor: campaign.gradient_color,
    },
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSubmit(formValues) {
      dispatch(
        setData(NEW_CAMPAIGN_ID, {
          background_image: formValues.backgroundImage,
          background_image_filename: formValues.backgroundImageFilename,
          background_pan: formValues.backgroundPan,
          gradient_color: formValues.gradientColor,
        })
      )
      dispatch(goBack())
    },
  }
}

export default reduxForm(
  {
    form: 'create_cover',
    destroyOnUnmount: false,
    fields: [
      'gradientColor',
      'backgroundImage',
      'backgroundImageFilename',
      'backgroundPan',
    ],
    touchOnBlur: false,
    touchOnChange: false,
  },
  mapStateToProps,
  mapDispatchToProps
)(PoolCoverCreate)
